module.exports = __webpack_public_path__ + "static/img/member_icon_3.8eb0a0fd.png";